/**
 * Created by vlad.p on 8/2/2017.
 */

export enum UserFlag {
    Default = 0,
    Disabled = 1
}


// WEBPACK FOOTER //
// ./app/objects/users/userFlag.ts